<template>
  <div class="container">
    <div class="news-detail">
      <div class="nd-body">
        <div class="bread-nav">
          <span @click="navgoTo()">全部</span> > 职场故事 >
          <span class="txt-gray">{{objData.title}}</span>
        </div>
        <div class="nd-body-content">
          <div class="nd-body-view">
            <div class="nd-body-view-title">{{objData.title}}</div>
            <div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 职场故事</div>
            <div class="nd-body-view-content">{{objData.content}}</div>
            <div class="nd-body-view-content">
              <img src="../../../static/Bitmap_4.jpg" alt="map" />
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
              <div>{{objData.contenta}}</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
              <div>{{objData.contentb1}}</div>
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
              <div>{{objData.contentc1}}</div>
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlee}}</h3>
              <div>{{objData.contente1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlef}}</h3>
              <div>{{objData.contentf1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
						
						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleg}}</h3>
              <div>{{objData.contentg1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleh}}</h3>
              <div>{{objData.contenth1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlei}}</h3>
              <div>{{objData.contenti1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlej}}</h3>
              <div>{{objData.contentj1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

						<div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlek}}</h3>
              <div>{{objData.contentk1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-of">
              <div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
              <div>下一篇：{{objData.next}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowNewsDetail",
  data() {
    return {
      id: "",
      objData: {
        title: `这十个职场小故事，让我受益一生`,
        date: `2019年9月12日`,
        froms: `播聘`,
        next: `播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
        prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
        content: `职场是每一个人必然要经历的人生阶段，职场的成功与失败，取决于一个人的知识、能力、经验和素质。
想起多年以前初入职场的我，一个毛头小伙，青涩幼稚，走过了好多职场的大坑，栽了很多跟头，一路摸爬滚打，闯到现在，也积累了一些经历和经验。
在我十多年职场生涯中，有十个小故事让我受益一生，分享给你，希望能够给你启发，让你少走职场的弯路。
`,
        subtitle: `细节`,
        contenta: `那一年，大学毕业不久，我一个人去北京闯荡，成为北漂一族。刚去的那些日子，开始找工作。不久，一所学校要面试我，我去那个学校见了主管人力资源的副校长，他带我去实验室找器材。
我们走过操场的时候，我脚上踢到了一个纸团，于是我走过去，把那个纸团捡起来，握在手中，等到遇到了垃圾桶，就把纸团扔进垃圾桶里。那个副校长看了我一眼，没说什么，等我试讲完毕之后，在办公室和他谈话的时候，我问他，我会被录用吗？他对我说，你知道吗，当你把那个纸团捡起来扔到垃圾桶的时候，你就已经就被录用了。
他的话让我无比兴奋，也无比感动。很多年过去了，他的这句话一直影响着我，激励着我，让我知道，职场的成败很大程度上取决于细节，我们是不是一个有耐心、细心、恒心的人。
这个故事听起来像假的，但是的确发生在我身上，我给好多年轻人讲过这个故事，我希望他们能够从中领悟一些东西。
细节决定成败，成为一个有素质有教养的人，会帮助你在职场上战无不胜。
`,

        subtitleb: `关系`,
        contentb: `在那所学校入职之后不久，我遇到了一个困境。不知道为什么，那个主管器材的老师，对我总是不友好。我去借什么器材，他都推三阻四不给我找，让我十分恼火，却又无济于事，因为我是个新来的，又是一个外地人，他可能对外地人有偏见，但是我一直没有发作。
有一天傍晚下班之后，我正在和一帮同事打球，看见他正拿着一把梯子想上房，应该是去修网线，于是我跑过去对他说，你别上了，太危险，让我上吧。那天晚上我一直帮他忙了一个小时，帮他做好了所有的一切，他一直不停的对我说谢谢。从那以后，他对我有求必应，十分热情的为我服务。
我用那一个小时的时间和付出，赢得了他的信任、尊敬和帮助。他还为我申请了200块钱的加班费。通过我无私的帮助，不但赢得了别人的尊重，处好了关系，还为自己赚到了利益。
这件事，让初入职场的我发现，在工作中我们不能只考虑到自己，应该热情的去帮助别人。帮助别人，其实就是在帮助我们自己，能为我们赢得一个和谐的人际关系。
一个和谐的人际关系，会让我们做什么事都畅通无阻。
`,
        //

        subtitlec: `用心`,
        contentc1: `我刚去那个学校的时候，学校给我安排了一门课，叫植物栽培，这是一门劳动技术课，没人愿意教，孩子不重视。
记得刚上第一节课的时候，纪律很乱，学生干什么的都有，幸好有一个孩子，热情的注视着我。他真诚热情的注视，给了我力量，也给了我信心，让我觉得如果不用心去讲，讲得不精彩，对不起他对我的目光。
于是，我把每一节课都精心准备，认真去上。不久，我就赢得了所有学生对我的尊敬和爱戴，甚至是热爱。那个从来不被重视的课程，居然成为了最受学生欢迎的课程。很多老师都很纳闷，这些孩子怎么就喜欢这么一门不重要的课呀。
这个事情让我懂得，即使是最平凡的工作，也可以做出花来，也可以成就自己，为自己赢得尊重和尊严。没有坏工作，只有坏态度。无论是什么工作，只要用心去做，都会取得令人意想不到的收获。
`,

        subtitled: `精彩`,
        contentd1: `我刚任教的第一周，领导就通知我，要到我班里听课。那几个夜晚我都很晚才睡，精心的设计每一个环节，甚至每一句话，我都做了精心准备。
听课那天，所有的校领导和相关老师20多人都来了，坐了满满一屋子。好在我准备的够充分，所以信心满满，整个过程精彩纷呈，行云流水，游刃有余。
当40分钟结束，我喊出下课的时候，所有学生起立为我鼓掌。那堂课，我不但赢得了学生，还赢得了所有领导和老师对我的欣赏，我用精彩的课堂，精彩的表现，证实了自己的实力和能力。
当机会来临，一定要紧紧抓住，一分耕耘一分收获，充分准备，才能有备无患，而且会带来奇效。

`,
        subtitlee: `担当`,
        contente1: `那天学校发生一件事，学校原先派去区里参加教师演讲大赛的那个老师，家里有事去不了了。第二天就要比赛，领导非常着急，问我们有没有能去的，我没有思考太多，主动请缨，告诉领导，我可以试试。
那个领导对我还不是很了解，所以还很怀疑，但是后来实在找不到更好的人选，只好让我去。
那天晚上我几乎没怎么睡觉，一直在精心的准备，因为我先前有过演讲的经验，有过这方面的训练，所以还难不倒我。
第二天去比赛的时候，我以优异的表现和精彩的演讲得到了第一名，把我们领导高兴坏了，下台之后给我一个大大的拥抱。从此，好多出头露面的机会就多了。
这个事情给我无限启发，关键时刻要勇于担当。这种担当，不但能为我们赢得机遇和机会，还能够锻炼我们的能力。
一个勇于担当的人，一定是在职场受欢迎受尊敬的人。

`,
        subtitlef: `挑战`,
        contentf1: `有一天，领导突然交给我一个任务，让我带领几个学生，去参加市里的科技创新大赛。参加这次大赛，需要做好多准备工作，尤其是需要做一个高质量的PPT，而我当时的PPT技术为零。
但是我勇敢的承担这次任务，开始真的很痛苦，因为我要一点一点的去学PPT制作，我用了一周时间就学会了，然后做出了一个一百多页的精美PPT。
之后，带着我的学生，去参加市级科技论坛大赛，居然夺得了一等奖，然后又去参加全国的科技创新大赛，获得全国二等奖。
那次挑战，不但让我学会了PPT制作技术，还为我赢得了很多的荣誉和机会。后来因为这个原因，我参加了第三届亚太经合组织青年科学节，成为科学节的辅导老师，学校和区教委还对我进行了重奖。
这个故事让我发现，人要不断的突破自己，挑战自我，挖掘自己的潜能，你才能发现自己未知的力量和潜力。
`,
        subtitleg: `圆满`,
        contentg1: `后来，我得到了另外一所学校的邀请，权衡之下，我决定跳槽，去那边学校任教。但是在临走之前，我和原学校的领导们真诚的沟通，并承诺会继续工作三个月，一直到辅导好我的接班人为止，因为我的一些工作只有我能完成。
所以虽然我已经决定走了，又在那一直干了三个多月，一直到把我的接班人培训的十分合格为止，才彻底离开那个学校。这件事情，为我赢得了良好的名声，那个学校的领导一只记挂着我，经常和我沟通，对我说，这里是你永远的家，到那边觉得不好的时候，随时回来。让我十分感动
这个故事给我的启发就是，在职场中要好聚好散，有始有终，即使是不想在一个地方呆了，也不要成为仇人。很多跳槽的人和原单位最后都成了仇人，这会对自己以后的职场留下不好的影响。所以，多做一点，付出一点，把事情做的圆满一点，不留遗憾，才是职场的顺利和成功之道。
`,
        subtitleh: `帮助`,
        contenth1: `有一年夏天，我放假在家，我的一个朋友找我去帮忙，去给一个学校做文史馆。我欣然应允，一开始只是在里面打打杂，做点小事，但后来因为人手急缺，我逐渐挑起了大梁，几乎负责起了所有的文字工作。
那一个多月的时间，我们几乎每天晚上都加班到凌晨三四点钟，但我无怨无悔，毫无怨言，兢兢业业的去做。那次工作，让我们做出了一个经典的文史馆，很多专家学者都赞不绝口。那次工作，也为我赢得了一次意外的机会，让我有机会到一个更大的机构和平台去工作
这个故事，给我无限启发。有些时候，我们看似是在帮助别人，实际是在成就自己，我们看似是在为别人工作，实际上是在为自己创造价值。所以，在职场中多做一些，没坏处。
`,
        subtitlei: `慎独`,
        contenti1: `这个故事我给别人讲的时候，很多人都说，你有病吧。我不知道你看完这个故事之后会有什么样的反应，还是先讲给你听吧。
我在北京那所学校工作时，加入了一个环保组织，做了一些跟环保有关的科学研究和实验，实验成果还获得了全国二等奖。这个过程让我变成了一个真正的环保人士，在生活各方面以身作则，做一些跟环保有关的事情。
有一次我去参加一次考试，考试之前我去厕所，从厕所出来的时候，我恍惚觉得有一个水龙头没有关严在滴水，但是由于当时马上就要考试了，我急匆匆的没有考虑那么多，就去考场参加考试。
可是坐在考场的时候，我总是心神不宁，总是在想那个滴水的水龙头而无心考试。最后实在没办法，我举手对老师说，我要去厕所。监考老师让我去了，我就是去厕所把那个水龙头给关上，让它不再滴水，然后回到教室，踏踏实实的继续考试。
讲这个故事，我要说什么呢？在没有别人的时候，你能不能做一个更好的自己，你能不能管理好你自己，你能不能还像在人前那样严格要求自己，这就是所谓的慎独。
很多人都是两面的人，人前一面，人后是另外一面。真正管理好自己的标志，就是无论在人前和人后都能用最好的标准要求自己。我们在细微处都更好的去要求自己的时候，甚至把它变成一种习惯，化成我们血液的时候，我们才真正做到了，达到了。
`,
        subtitlej: `自律`,
        contentj1: `很多人到了职场之后，初始的兴奋劲度过之后，大多数人开始随波逐流，不思进取，就这样浑浑噩噩的度过。职场初期，我也经历过一段迷茫期，后来觉得日子不能这样过下去，我必须对自己有所要求，让自己做一些有价值的事。
于是从那年开始，我要求自己必须做到这几件事：第一，每学期都要至少做一堂完美的公开课，一堂可以载入我人生史册的精彩课；第二，每个月都要完成一篇高质量的教学论文；第三，每周都要写一篇教学反思；第四，每天都要写一篇日记；第五，每天都要至少跑步五公里。
通过对自己这样的要求，我让自己保持一个良好的状态，不断的去积累。运动，让我有一个健康的身体；写作，让我不断积累专业；精彩课程，让我为人生留下精彩。对自我的不断要求，让我在专业上不断前进，在成就上不断突破，从而逐渐让自己成为一个优秀的员工，在这里，我找到了自己的意义感和价值感，也不断的收获了成就感。
以上十个小故事，都是我在职场初期，经历的一些难忘的事件，从中我收获了成长、成绩、成功，以及很多的机会。正是在职场中不断的反思、积累、提升自我，让我永远在职场中立于不败之地。
`
      }
    };
  },
  created(option) {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.id = _this.$route.query.id || ``;
    },
    navgoTo() {
      this.$nav({ path: `/show-news` }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./show-story.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-story/show-story.vue